var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRewind = function SvgIconRewind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none",
    viewBox: "0 0 22 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6D3F",
    d: "m11.599 6.233 9.223-6.15a.5.5 0 0 1 .777.417v14.132a.5.5 0 0 1-.777.416l-9.223-6.15v5.734a.5.5 0 0 1-.777.416L.222 7.982a.5.5 0 0 1 0-.832l10.6-7.066a.5.5 0 0 1 .777.416z"
  })));
};
export default SvgIconRewind;